const $ = require('jquery');

import picturefill from 'picturefill';
import lazysizes from 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import AOS from 'aos';
import 'aos/dist/aos.css';
import slick from 'slick-carousel';
// import colorbox from 'jquery-colorbox';

const shizenkan = (() => {

	// 変数宣言
	const pointSP = window.matchMedia('screen and (max-width: 767px)');
	let scrollY;

	const $trigger = $('.menu-trigger');
	const $nav = $('.nav-global');
	const $sitemapTrigger = $('.nav-sitemap__headline');

	// このJSのinit
	function init() {

		AOS.init({
			offset: 100,
			duration: 1200,
			once: true
		});

		pagetopFunction();
		menuTrigger();

		googlemap();
		slide();

		pointSP.addListener(checkBreakPoint);
		checkBreakPoint(pointSP);
	}

	// 関数 ------------------------------------
	function fixedBG() {
		scrollY = $(window).scrollTop();
		$('body').addClass('is-fixed').css('top', -scrollY);
	}

	function fixedBGReset() {
		$('body').removeClass('is-fixed').removeAttr('style');
		$('html, body').scrollTop(scrollY);
	}

	function pagetopFunction() {
		$('a[href^="#"]').on('click.smoothScroll', (event) => {
			const speed = 1200;// ミリ秒
			const href = $(event.currentTarget).attr("href");
			const target = $(href == "#" || href == "" ? 'html' : href);
			const position = target.offset().top;
			$('html, body').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});

		// ページトップボタン表示処理
		const $pagetop = $('.pagetop');
		const headerHight = $('.header').outerHeight();
		$pagetop.hide();
		$(window).on('load scroll', (event) => {
			// スクロールしたらボタン表示
			if ($(event.currentTarget).scrollTop() > headerHight){
				$pagetop.fadeIn();
			} else{
				$pagetop.fadeOut();
			}

			pagetopFixed();
		});

		function pagetopFixed() {
			// スクロールしたらフッター上に固定
			const scrollHeight = $(document).height();
			const scrollPosition = $(window).height() + $(window).scrollTop();
			const footerHeight = $('.footer').outerHeight();

			if (scrollHeight - scrollPosition <= footerHeight){
				$pagetop.removeClass('is-fixed');
			}
			else{
				$pagetop.addClass('is-fixed');
			}
		}
	}

	function menuTrigger() {
		$trigger.on('click', (event) => {
			$(event.currentTarget).toggleClass('is-active');
			$nav.stop().slideToggle();
		});
	}

	function sitemapAccodion() {
		$sitemapTrigger.on('click', (event) => {
			$(event.currentTarget).toggleClass('is-active');
			$(event.currentTarget).next().stop().slideToggle();
		});
	}

	function googlemap() {
		const $map = $('[id^="map"]');
		if($map.length) {
			const latlng = new google.maps.LatLng($map.data('lat'), $map.data('lng'));
			const myOptions = {
				zoom: 17,/*拡大比率*/
				center: latlng,/*表示枠内の中心点*/
				scrollwheel: false,/*スクロール不可*/
				mapTypeControlOptions: { mapTypeIds: ['map', google.maps.MapTypeId.ROADMAP] }/*表示タイプの指定*/
			};
			const icon = {
				url: '/assets/img/common/ic_pin.png',
				scaledSize: new google.maps.Size(134, 139),
			}
			const map = new google.maps.Map(document.getElementById('map'), myOptions);
			const markerOptions = {
				position: latlng,
				map: map,
				icon: icon,
				title: '至善館'
			};
			const marker = new google.maps.Marker(markerOptions);
			/*取得スタイルの貼り付け*/

			var styleOptions = [
				{
					"stylers": [
							{
								"hue": "#999999"
							},
							{
								"saturation": -255
							}
					],
					"elementType": "all",
					"featureType": "all"
				}
			];
			const styledMapOptions = { name: '至善館' };
			const mapType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
			map.mapTypes.set('map', mapType);
			map.setMapTypeId('map');
		}
	}

	function slide() {
		const $slide = $('[class*="slide"]');

		if($slide.length){
			$('.slide-detail').slick({
				adaptiveHeight: true,
				autoplay: true,
				arrows: false,
				dots: true,
			});

			$('.slide-faculy').slick({
				adaptiveHeight: true,
				autoplay: true,
				arrows: true,
				dots: false,
				slidesToShow: 4,
				appendArrows: $('.area-program-faculty-voice__slider-arrows'),
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							centerMode: true,
							centerPadding: '20px',
						}
					}
				]
			});

			$('.js-slide').slick({
				adaptiveHeight: true
			});
		}
	}

	function modal() {
		const $modal = $('[class*="modal"]');

		if($modal.length){
			$('.modal-btn').colorbox({

			});
		}
	}

	function checkBreakPoint(pointSP) {
		if (pointSP.matches) {
			sitemapAccodion();
		} else {
			$trigger.removeClass('is-active');
			$nav.removeAttr('style');
			$sitemapTrigger.removeClass('is-active').next().removeAttr('style');
		}
	}
	// -----------------------------------------

	return {
		init : init
	};

})();

// このタイミングで実行
$(() => {
	shizenkan.init();
});
